import { Updater, AsyncState, Unit, unloadedAsyncState } from "widgets-for-react"
import { UserSubscriptions } from "../subscriptionState"
import * as Api from "./stopSubscriptionApi"
import { loadUserSubscriptions } from "../subscriptionApi"


export type StopSubscriptionState = {
  areYouSure?: boolean // Null in case the checkbox has not been set / interacted with yet
  subscriptionToStop: AsyncState<UserSubscriptions>
  isValid(): boolean
  stopSubscription: AsyncState<Unit>
  asyncsFailed: () => boolean
  asyncsWorkingDisableInput: () => boolean
}

export const initialStopSubscriptionState = (userSubscriptionsState: AsyncState<UserSubscriptions>) : StopSubscriptionState => ({
  // If we navigated from the account details page, the userSubscriptionsState will be loaded already and we can use that
  // If we navigated directly to this page via browser navigation, we still need to load the subscriptions as we will have no prior data.
  subscriptionToStop: userSubscriptionsState.kind === 'loaded' ? userSubscriptionsState : loadUserSubscriptions(),
  stopSubscription: unloadedAsyncState(),
  isValid: function (this: StopSubscriptionState): boolean {
    return this.areYouSure == true;
  },  
  // utility to disable stuff in bulk when other async calls are running
  asyncsFailed:function(this:StopSubscriptionState) {
    const asyncFailed = <a>(a:AsyncState<a>) : boolean => a.kind == "failed" || a.kind == "unauthorized"
    return asyncFailed(this.subscriptionToStop)
  },
  asyncsWorkingDisableInput:function(this:StopSubscriptionState) {
    const asyncWorking = <a>(a:AsyncState<a>) : boolean => a.kind != "loaded" && a.kind != "unloaded" && a.kind != "failed"
    return asyncWorking(this.subscriptionToStop)
  }
})

export const stopSubscriptionUpdaters = {
  areYouSure: (updater: Updater<StopSubscriptionState["areYouSure"]>) : Updater<StopSubscriptionState> =>
    state => {
      return ({ ...state, areYouSure: updater(state.areYouSure) });
    },
  /*
    // This appears unused in main branch
  requestSubscriptionStop: (subscription: ActiveSubscription) : Updater<StopSubscriptionState> => state => 
    state.stopSubscription.kind == "unloaded" ||
    state.stopSubscription.kind == "loaded" ?
      ({...state, stopSubscription: Api.terminateActiveSubscription(subscription) })
    : state,
    */
  invokeStopSubscriptionApi: (state: StopSubscriptionState) : StopSubscriptionState => 
    {
      if(state.subscriptionToStop.kind != "loaded" || state.subscriptionToStop.value.ActiveSubscription.length <= 0) {
        return state;
      }

      return (state.stopSubscription.kind == "unloaded" || state.stopSubscription.kind == "loaded") ?
        ({ ...state, stopSubscription: Api.terminateActiveSubscription(state.subscriptionToStop.value.ActiveSubscription[0]) })
        : state;
    },
  // Below function makes sure that the state is updated when the call to loadUserSubscriptions() from the initialStopSubscriptionState finishes
  subscriptionToStopLoaded: (updater: Updater<AsyncState<UserSubscriptions>>) =>
      (state: StopSubscriptionState): StopSubscriptionState => 
      {
        return ({
          ...state,
          subscriptionToStop: updater(state.subscriptionToStop)
        })
      },
  // Below function makes sure that the state is updated when the call to Api.terminateActiveSubscription() from the invokeStopSubscriptionApi finishes
  stopSubscriptionFinished: (updater: Updater<AsyncState<Unit>>) =>
    (state: StopSubscriptionState): StopSubscriptionState => 
    {
      return ({
        ...state,
        stopSubscription: updater(state.stopSubscription)
      })
    }
}
